import React from "react";
import PropTypes from "prop-types";

const ChatMessage = ({ chat }) => {
  return (
    <div key={chat.message} className={`chat-bubble ${chat.sender}`}>
      <h6
        className={`sender-name ${chat.sender}-name ${
          chat.type === "you" ? "text-end" : ""
        }`}
      >
        {chat.sender}
      </h6>
      <p className={`chat-message ${chat.type === "you" ? "text-end" : ""}`}>
        {chat.text}
      </p>
      <div
        style={{ fontSize: "12px" }}
        className={`text-muted ${chat.type === "you" ? "text-end" : ""}`}
      >
        {chat.time}
      </div>
    </div>
  );
};

export default ChatMessage;

ChatMessage.propTypes = {
  chat: PropTypes.any.isRequired,
};
